// npm packages
import React, { useState, useContext, useEffect } from "react";
import context from "context/context";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import { exportHeaders } from "./export";

// custom pages
import { styles } from "./styles";
import Loader from "components/Loader/Loader";
import Table from "components/Table/Table";
import ApprovalAPI from "apis/approval/approval";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import { useTranslation } from 'react-i18next';

function History(props) {
  const { state, dispatch } = useContext(context);
  const classes = styles();
  const goBack = props.goBack;
  const { getApprovalsHistory, approvalsHistoryFilter, handleExportData } =
    ApprovalAPI();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState(false);
  const [checkedApproved, setCheckedApproved] = useState(false);
  const [checkedRejected, setCheckedRejected] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [filterValue, setFilterValue] = useState(null);
  const [exportData, setExportData] = useState([]);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (filterApplied) {
      handleFilter(filterValue);
    } else {
      handleGet();
    }
  }, [offset]);

  // for breadcrumb
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "ADMIN", "History"] });
  }, []);

  const handleGet = async () => {
    try {
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getApprovalsHistory(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  async function handleFilter(value) {
    try {
      setFilterApplied(true);
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
        type: value,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await approvalsHistoryFilter(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  async function handleExport() {
    try {
      let values = {};
      if (filterValue) {
        values = { ...values, type: filterValue };
      }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await handleExportData(values);
      if (res) {
        setExportData(res.data);
        setCount(res.count);
        dispatch({ type: "SET_LOADING", payload: false });
        return true;
      }
      return false;
    } catch (e) {
      console.log({ e });
    }
  }

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  return (
    <React.Fragment>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <Button className={classes.backBtn} onClick={goBack}>
            {t('Back')}
          </Button>
        </div>
        <div>
          <Button
            className={`${classes.backBtn} ${classes.filterBtn}`}
            onClick={() => setFilter(!filter)}
          >
           {t('Filter')} 
          </Button>
          <Button
            className={`${classes.backBtn} ${classes.filterBtn}`}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </Button>
        </div>
      </div>

      {filter && (
        <div className={`${classes.filterCardDiv} ${classes.filterCardDivSub}`}>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={2}
                  className={classes.filterCardGridContainer}
                  style={{ padding: 10 }}
                >
                  <Grid item xs={4} className={classes.filterCardGrid}>
                    <Checkbox
                      inputProps={{
                        "aria-label": "uncontrolled-checkbox",
                      }}
                      onChange={() => {
                        setCheckedApproved(!checkedApproved);
                        setCheckedRejected(false);
                        setFilterValue(1);
                        handleFilter(1);
                        setOffset(1);
                      }}
                      color="primary"
                      size="medium"
                      checked={checkedApproved}
                      style={{ margin: 0 }}
                    />
                    <span
                      className={classes.filterCardHeadText}
                      style={{
                        verticalAlign: "middle",
                        fontSize: "0.875rem",
                      }}
                    >
                      {t('Approved')}
                    </span>
                  </Grid>
                  <Grid item xs={4} className={classes.filterCardGrid}>
                    <Checkbox
                      inputProps={{
                        "aria-label": "uncontrolled-checkbox",
                      }}
                      onChange={() => {
                        setCheckedRejected(!checkedRejected);
                        setCheckedApproved(false);
                        setFilterValue(2);
                        handleFilter(2);
                        setOffset(1);
                      }}
                      color="primary"
                      size="medium"
                      checked={checkedRejected}
                      style={{ margin: 0 }}
                    />
                    <span
                      className={classes.filterCardHeadText}
                      style={{
                        verticalAlign: "middle",
                        fontSize: "0.875rem",
                      }}
                    >
                      {t('Rejected')}
                    </span>
                  </Grid>
                  <Grid item xs={4} className={classes.filterCardBtnGrid}>
                    <Button
                      className={classes.filterCardApplyBtn}
                      style={{
                        fontSize: "0.875rem",
                        height: 35,
                      }}
                      onClick={() => {
                        setFilterValue(null)
                        setCheckedRejected(false);
                        setCheckedApproved(false);
                        setFilterApplied(false);
                        setOffset(1);
                        handleGet();
                      }}
                    >
                      {t('Reset')}
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}

      <Loader Loading={state.loading} top={"15%"}>
        <Grid className={classes.tableDownInResponsive}>
          <Grid xs={12} sm={12} lg={12}>
              <Table
                headings={[
                  "Customer Account Number",
                  "Billing Account Number",
                  "Sales Division Code",
                  "Market Class Code",
                  "Segment Code",
                  "Type",
                  "Status",
                ]}
                data={data?.map((p, i) => [
                  p?.["Customer_Account.customer_account_number"],
                  p?.["Customer_Account.customer_billto_account_number"],
                  p?.["Customer_Account.customer_sales_division_code"],
                  p?.["Customer_Account.market_class_code"],
                  p?.["Customer_Account.segment_code"],
                  (p?.["One_Web_Request.type"] &&
                    ((p?.["One_Web_Request.type"] === 1 && t("Enrollment")) ||
                      (p?.["One_Web_Request.type"] === 2 && t("Transfer")))) ||
                    (p?.["type"] &&
                      ((p?.["type"] === 1 && t("Enrollment")) ||
                        (p?.["type"] === 2 && t("Transfer")))),
                  p?.approval_status == 1 ? (
                    <span style={{ color: "green" }}>{t("Approved")}</span>
                  ) : (
                    <span style={{ color: "red" }}>{t("Rejected")}</span>
                  ),
                ])}
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
          </Grid>
        </Grid>
      </Loader>
      <CSVLink
        id="csv"
        data={exportData}
        headers={exportHeaders.map((head) => head)}
        filename={
          `Approvals` +
          " " +
          moment(new Date()).format("MM-DD-YYYY,h:mm A") +
          ".csv"
        }
        className={classes.CSVlink}
      />
    </React.Fragment>
  );
}

export default History;
